<template>
  <v-app class="pldc" style="height: 100%; max-width: 450px;"
    :class="{on_desktop: $vuetify.breakpoint.smAndUp}"
  >
    <AppHeader :name="me.name" :account_name="account_name" />
    
    <v-main style="height: calc(100% - 115px);">
      <router-view />
    </v-main>

    <NavFooter />
  </v-app>
</template>

<script>
import AppHeader from './Header'
import NavFooter from './NavFooter'

import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'AppLayout',

  components: { AppHeader, NavFooter },
  
  data: () => ({
    keepAliveTimer: null,
  }),

  computed: {
    ...mapGetters('auth', ['me', 'signedIn']),

    account_name() {
      return this.me.account ? this.me.account.account_name : ''
    },
  },

  watch: {
    signedIn(is_logged_in) {
      if (!is_logged_in) {
        this.$router.push({ name: 'login' })
      }
    }
  },

  methods: {
    ...mapActions('auth', ['loadMe']),

    keepAlive() {
      this.loadMe()
    }
  },

  created() {
    // check for life every 2 minutes
    this.keepAliveTimer = setInterval(this.keepAlive, 120 * 1000)
  },

  beforeDestroy() {
    clearInterval(this.keepAliveTimer)
  }
}
</script>

<style>
  html, body {
    height: 100%;
  }

  .v-application--wrap {
    min-height: 100vh !important;
    min-height: -webkit-fill-available !important;
  }
</style>